import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTrash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16 4v2.999L20 7v1l-2.066-.001L17.143 20H6.857L6.066 7.999 4 8V7l4-.001V4zm1 4H7l.737 11h8.526zm-4.5 1v9h-1V9zM10 9v9H9V9zm5 0v9h-1V9zm0-4H9v2h6z" />
  </svg>
);
export default SvgTrash;
